import type { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import type { AIconProps } from '../../atoms/AIcon/AIcon.types';

export enum MListNavItemState {
  Default = 'Default',
  Active = 'Active',
  Disabled = 'Disabled',
}

export type MListNavItemProps = {
  text: string;
  arrow?: boolean;
  state?: MListNavItemState;
  aIcon?: AIconProps;
};

export type MListNavGroupVerticalProps = {
  showSubheader?: boolean;
  aSubheader?: ASubheaderProps;
  items?: MListNavItemProps[];
};
